import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean;
}

const useStyles = makeStyles<Props>({ name: 'CartIcon' })(
  (
    { typography: { pxToRem }, brandColors, type, breakpoints },
    { isOnDark }
  ) => ({
    button: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      position: 'relative',

      '& > svg': {
        color: darkOrLightStyle({ isOnDark })(
          brandColors.white,
          brandColors.black
        ),
      },
    },
    qty: {
      ...type['12_chip'],
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: pxToRem(20),
      height: pxToRem(20),
      color: brandColors.white,
      backgroundColor: brandColors.errorMain,
      borderRadius: pxToRem(100),
      transform: 'translate(50%, -25%)',
      [breakpoints.up('md')]: { transform: 'translate(50%, -50%)' },
    },
  })
);

export default useStyles;
